{
    "Accessibility menu": "رسائی مینو",
    "Close": "بند کریں",
    "Content adjustments": "مواد کی ایڈجسٹمنٹ",
    "Navigation adjustments": "نیویگیشن کی ایڈجسٹمنٹ",
    "Text Align": "Text Align",
    "Align Left": "بائیں جانب ترتیب دیں",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "فونٹ سائز ایڈجسٹ کریں",
    "Highlight Title": "عنوان کو نمایاں کریں",
    "Highlight Links": "لنکس کو نمایاں کریں",
    "Readable Font": "قابلِ مطالعہ فونٹ",
    "Colour adjustments": "رنگ کی ایڈجسٹمنٹ",
    "Dark Contrast": "گہرا تضاد",
    "Light Contrast": "ہلکا تضاد",
    "High Contrast": "زیادہ تضاد",
    "High Saturation": "زیادہ سیچوریشن",
    "Low Saturation": "کم سیچوریشن",
    "Monochrome": "مونوکروم",
    "Tools": "اوزار",
    "Reading Guide": "مطالعہ گائیڈ",
    "Big Cursor": "بڑا کرسر",
    "Increase Font Size": "فونٹ سائز بڑھائیں",
    "Decrease Font Size": "فونٹ سائز کم کریں",
    "Letter Spacing": "حروف کا فاصلہ",
    "Line Height": "لائن کی اونچائی",
    "Font Weight": "فونٹ کا وزن",
    "Dyslexia Font": "ڈسلیکسیا فونٹ",
    "Language": "زبان",
    "Accessibility widget": "رسائی مینو کھولیں",
    "Accessibility Profiles": "رسائی پروفائلز",
    "Cognitive Disability": "ادراکی معذوری",
    "Seizure Safe": "دورے سے محفوظ",
    "Accessibility statement": "رسائی کا بیان",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "حرکات روکیں",
    "Animation paused": "اینیمیشن روک دی گئی",
    "Reset all settings": "ترتیبات ری سیٹ کریں",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
